export const perspectiveData = [
  {
    id: 1,
    img: "",
    name: "Ayush Gupta",
    position: "Assistant Assigning Editor, Personal Loans",
    paraOne:
      "Doing thorough research helps ensure you find the lender that sees you as an ideal customer, which can result in better rates and terms. Choosing the right lender can save you money in the long term.",
    paraTwo:
      "  This is why doing your research is so important. If you're rate shopping with lenders that don't see you as their ideal borrower, you could be missing out on a better offer elsewhere.",
  },
];
